import React, { useState } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { Link } from "react-router-dom";

function Navbar() {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };
  const navLinks = [
    { href: "/", label: "Home" },
    { href: "#about", label: "About" },
    { href: "#certification", label: "Certification" },
    { href: "#contact", label: "Contact" },
    { href: "#work", label: "Works" },
    { href: "#skills", label: "Skills" },
    { href: "#timeline", label: "Timeline" },
    { href: "#links", label: "Links" },
  ];

  return (
    <div className="fixed top-0 w-full bg-black text-gray-400 h-[100px] z-50 ">
      <div className="max-w-[1200px] mx-auto flex justify-between items-center h-full">
        <a href="#top">
          <h1 className="text-3xl font-bold primary-color ml-4">Anmol Shah</h1>
        </a>
        <ul className="hidden md:flex uppercase text-sm">
          {navLinks.map((link) => (
            <li key={link.href} className="p-2">
              <a href={link.href}>{link.label}</a>
            </li>
          ))}
        </ul>
        <div onClick={handleNav} className="block md:hidden mr-6">
          {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
        </div>
      </div>
      <div
        className={
          nav
            ? "z-10 fixed h-full left-0 top-0 w-[60%] bg-[#202121] ease-in-out duration-500"
            : "fixed left-[-100%]"
        }
      >
        <h1 className="text-3xl primary-color m-4">Anmol Shah</h1>
        <ul className="p-8 text-2xl">
          {navLinks.map((link) => (
            <li key={link.href} className="p-2">
              <a href={link.href} onClick={handleNav}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
export default Navbar;
